module.exports = __webpack_public_path__ + "img/losing_money.038752a7.svg";